<script>
    import { selectedLanguage } from "../etc/store.js"
</script>

{#if $selectedLanguage == "TW"}
【XiYi 習易網】是一個提供學習易經的人平常讀易、玩易、起卦、解卦、紀錄卦例與心得的方便所在。

千百年來，學易的人無數，大多數的人可能都是熱鬧一場，最後成效不彰。
學易難成的原因千百種，我猜，最主要的可能是符號抽象加上古書難懂；第二，很多人，包括 3、40 年前的我自己在內，認為「讀易經（周易、十翼）」就是「學易」，只重易理、而不重易數（術），結果就是：學而不習，學而不知要習，學而不知要怎麼習，因而成效不彰。所以，就我個人而言，我認同李伯彥老師說的：**「我們要透過學習易經來鍛鍊自己的認知能力以及看事情的寬度、廣度、以及深度」**，我也同意劉君祖老師所說的 **「借占習易，借易修行」**，我覺得學習易經可以提醒我觀察、理解世界的變化，也能幫助我進德修業，這也是我個人習易的基本動機：希望成為一個更好的自己。

而您，又為什麼想要學易、習易呢？不管您學易的動機是什麼、學易到了什麼階段，【XiYi 習易網】都應該能夠在您習易時的操作層面上，為您提昇學習的效率：

- **習易的時間、地點都不再是限制：** 無論您在機場、捷運、還是在任何地方，只要手邊有能夠上網的電腦、平板、或是手機，靈光一閃、心念所至，您可以隨時、隨地、隨手查閱重要易經古籍、起卦、紀錄心得、以及練習各種爻的變化對卦象的影響。

- **學易可以不再需要「韋編三絕」：** 不是每一個人都有「Eidetic memory (photographic memory)」。就算您把將近 5 千多字的易經全文背熟，面對本卦，有多少人能夠立刻將其綜卦、錯卦、交卦、互卦、還有 5 個卦中卦，及其相關所有卦象、卦爻辭、各爻間承乘應與、當位、得中的種種關係，映入腦海呢？一旦起卦，多半還有變卦（第一、第二之卦）。在【XiYi 習易網】裡，點擊任何一卦，除了周易的卦象、辭、彖、大、小象之外，其所有的爻和相關卦也都是可以與您互動的。

- **自行輸入、卦例上傳、自動起卦：** 不管您喜歡用金錢卦、大衍筮法還是別的方法，只要可以輸入 6 個【6 ～ 9】的數字就成一卦。您之前累積的卦例也可以整理出來上傳。【XiYi 習易網】也有電腦自動起卦功能，您也可以試試。所有進入系統到的卦例，都可以展現其之卦、變卦、錯卦、綜卦、卦中卦，以便全面參考理解。您也可以針對每一卦，紀錄您的心得與解卦，也可以隨時回頭複習。

- **習易紀錄：** 您可能現在用的是筆記本、Excel、Google Sheet、或是其他紀錄卦例的方法，我以前也是。可是，時間久了，掛例多了，不但搜尋不易，想要相互參考相關卦例更難。【XiYi 習易網】提供了卦例紀錄、基本搜尋的功能。除了儲存您的卦例，您還可以隨時紀錄或更新自己的解卦和心得。所有的卦例，都可以加註類別和標記，以便將來搜尋、複習、驗證相關占卦紀錄。

- **列印及下載卦例：** 除了您可以隨時列印您的卦例之外，我理解您的卦例就是您的心血與智慧財產。無論是您想離開【XiYi
  習易網】、或是有一天出現了比【XiYi 習易網】更好的服務，您可以隨時下載您所有的卦例以及相關解卦和心得紀錄，以便上傳到新的系統。

- **會員的隱私與文件加密：** 【XiYi 習易網】非常重視網路安全以及個人隱私，使用 HTTPS 標準加密，傳送所有資料從用戶端到 Google Firebase 的雲端服務。根據 Google Firebase 的文件，所有儲存在其雲端硬體的內容也是自動加密的。除了這兩項基本網路安全架構之外，【XiYi 習易網】還對所有會員輸入卦例的「問題」、以及複習卦例時增添的「筆記」和「解卦」內容在用戶端（client side）傳送前就額外加密。例如，如果您起卦的問題是「我追求王小花的前景如何」，您使用的網路瀏覽器在傳送這個問題之前，就會自動把它加密成類似這樣的亂碼「BQkHV64/S3Sz1yU+SbkIo4Jg=...」，這樣一來，就算是我在維護整理網路資料庫的時候，也不會一不小心就看到了您卦例中「問題」、「筆記」和「解卦」的內容。

看到這裡，您大概已經猜到，【XiYi 習易網】的背後，就是我一個人。您猜對了！

一個人，有一個人的好處：

- 因為我自己學易，所以我遇到的問題、需要的功能，很可能對您也有幫助。
- 因為只有我一個人，我必須儘量用最基本的開源的技術元件來製作，只有這樣，出了問題，我才比較有可能持續性地解決各種各樣的 Bugs。
- 因為只有我一個人，只要我還在學易、習易、寫程式，我就會繼續改善【XiYi 習易網】，這和我從這裡賺到多少錢關係不大。換句話說，【XiYi 習易網】並不是一個完全以收入為導向的事業單位。
- 我一個人就可以決定要做什麼、怎麼做、什麼時候做。所以，要是您有想要的功能、有任何建議，或是發現【XiYi
  習易網】有任何錯誤、不好用的地方，<a href="mailto:ixiyi88@gmail.com">歡迎 email 和我聯絡</a> 。我會盡力來處理。

當然，也因為是我一個人利用空餘時間開發這個習易的工具，如遇到使用上的問題、錯誤，大家也請用耐心、多體諒包涵。
{:else }
【XiYi 习易网】是一个提供学习易经的人平常读易、玩易、起卦、解卦、纪录卦例与心得的方便所在。

千百年来，学易的人无数，大多数的人可能都是热闹一场，最后成效不彰。
学易难成的原因千百种，我猜，最主要的可能是符号抽象加上古书难懂；第二，很多人，包括 3、40 年前的我自己在内，认为「读易经（周易、十翼）」就是「学易」，只重易理、而不重易数（术），结果就是：学而不习，学而不知要习，学而不知要怎么习，因而成效不彰。所以，就我个人而言，我认同李伯彦老师说的：**「我们要透过学习易经来锻炼自己的认知能力以及看事情的宽度、广度、以及深度」**，我也同意刘君祖老师所说的 **「借占习易，借易修行」**，我觉得学习易经可以提醒我观察、理解世界的变化，也能帮助我进德修业，这也是我个人习易的基本动机：希望成为一个更好的自己。

而您，又为什么想要学易、习易呢？不管您学易的动机是什么、学易到了什么阶段，【XiYi 习易网】都应该能够在您习易时的操作层面上，为您提升学习的效率：

- **习易的时间、地点都不再是限制：** 无论您在机场、捷运、还是在任何地方，只要手边有能够上网的电脑、平板、或是手机，灵光一闪、心念所至，您可以随时、随地、随手查阅重要易经古籍、起卦、纪录心得、以及练习各种爻的变化对卦象的影响。

- **学易可以不再需要「韦编三绝」：** 不是每一个人都有「Eidetic memory (photographic memory)」。就算您把将近 5 千多字的易经全文背熟，面对本卦，有多少人能够立刻将其综卦、错卦、交卦、互卦、还有 5 个卦中卦，及其相关所有卦象、卦爻辞、各爻间承乘应与、当位、得中的种种关系，映入脑海呢？一旦起卦，多半还有变卦（第一、第二之卦）。在【XiYi 习易网】里，点击任何一卦，除了周易的卦象、辞、彖、大、小象之外，其所有的爻和相关卦也都是可以与您互动的。

- **自行输入、卦例上传、自动起卦：** 不管您喜欢用金钱卦、大衍筮法还是别的方法，只要可以输入 6 个【6 ～ 9】的数字就成一卦。您之前累积的卦例也可以整理出来上传。【XiYi 习易网】也有电脑自动起卦功能，您也可以试试。所有进入系统到的卦例，都可以展现其之卦、变卦、错卦、综卦、卦中卦，以便全面参考理解。您也可以针对每一卦，纪录您的心得与解卦，也可以随时回头复习。

- **习易纪录：** 您可能现在用的是笔记本、Excel、Google Sheet、或是其他纪录卦例的方法，我以前也是。可是，时间久了，挂例多了，不但搜寻不易，想要相互参考相关卦例更难。【XiYi 习易网】提供了卦例纪录、基本搜寻的功能。除了储存您的卦例，您还可以随时纪录或更新自己的解卦和心得。所有的卦例，都可以加注类别和标记，以便将来搜寻、复习、验证相关占卦纪录。

- **列印及下载卦例：** 除了您可以随时列印您的卦例之外，我理解您的卦例就是您的心血与智慧财产。无论是您想离开【XiYi
  习易网】、或是有一天出现了比【XiYi 习易网】更好的服务，您可以随时下载您所有的卦例以及相关解卦和心得纪录，以便上传到新的系统。

- **会员的隐私与文件加密：** 【XiYi 习易网】非常重视网路安全以及个人隐私，使用 HTTPS 标准加密，传送所有资料从用户端到 Google Firebase 的云端服务。根据 Google Firebase 的文件，所有储存在其云端硬体的内容也是自动加密的。除了这两项基本网路安全架构之外，【XiYi 习易网】还对所有会员输入卦例的「问题」、以及复习卦例时增添的「笔记」和「解卦」内容在用户端（client side）传送前就额外加密。例如，如果您起卦的问题是「我追求王小花的前景如何」，您使用的网路浏览器在传送这个问题之前，就会自动把它加密成类似这样的乱码「BQkHV64/S3Sz1yU+SbkIo4Jg=...」，这样一来，就算是我在维护整理网路资料库的时候，也不会一不小心就看到了您卦例中「问题」、「笔记」和「解卦」的内容。

看到这里，您大概已经猜到，【XiYi 习易网】的背后，就是我一个人。您猜对了！

一个人，有一个人的好处：

- 因为我自己学易，所以我遇到的问题、需要的功能，很可能对您也有帮助。
- 因为只有我一个人，我必须尽量用最基本的开源的技术元件来制作，只有这样，出了问题，我才比较有可能持续性地解决各种各样的 Bugs。
- 因为只有我一个人，只要我还在学易、习易、写程式，我就会继续改善【XiYi 习易网】，这和我从这里赚到多少钱关系不大。换句话说，【XiYi 习易网】并不是一个完全以收入为导向的事业单位。
- 我一个人就可以决定要做什么、怎么做、什么时候做。所以，要是您有想要的功能、有任何建议，或是发现【XiYi
  习易网】有任何错误、不好用的地方，<a href="mailto:ixiyi88@gmail.com">欢迎 email 和我联络</a> 。我会尽力来处理。

当然，也因为是我一个人利用空余时间开发这个习易的工具，如遇到使用上的问题、错误，大家也请用耐心、多体谅包涵。
{/if}

<style>
    p {
    font-size: 16px;
  }
    li {
    font-size: 16px;
  }
    ul li {
    margin-left: 40px;
    list-style-type: square !important;
  }
</style>
